export default __webpack_public_path__ + "static/media/paymente.d66f8fc3.png";